// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BehanceCircleFilledSvg from "@fishx/icons-svg/es/asn/BehanceCircleFilled";
import FishxIcon from '../components/FishxIcon';

var BehanceCircleFilled = function BehanceCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BehanceCircleFilledSvg
  }));
};

BehanceCircleFilled.displayName = 'BehanceCircleFilled';
export default React.forwardRef(BehanceCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BehanceCircleFilled.js
// module id = 2059
// module chunks = 0